import { Directive } from "@angular/core";

/**
 * A wrapper for page content in view components with consistent padding and layout.
 *
 * This directive should be used to wrap the main content area of view components,
 * providing consistent spacing and layout across the application.
 *
 * @example
 * <mgd-page-content>
 *   <mat-card>...</mat-card>
 * </mgd-page-content>
 *
 * @selector mgd-page-content
 */
@Directive({
    selector: "mgd-page-content",
    host: {
        class: "mgd-page-content"
    }
})
export class PageContentDirective {}
